import { render } from "./IntentionsIcon.vue?vue&type=template&id=68fbc3f9"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__